import { Skeleton } from '@mui/material';
import { useQuery } from '@tanstack/react-query';

import { Alert, api, getQueryProps } from 'common';

import { useFlowDefinitionContext } from '../../../../../context';
import { BlockSelectField } from '../../../ConfigFields/SelectField';

export function AssistantFormFields() {
  const { flowDefinition } = useFlowDefinitionContext();
  const {
    data: assistants,
    isPending,
    isError,
    error,
  } = useQuery(
    getQueryProps(api.client.VoiceAssistant, 'findAllPaginated', {
      organizationId: flowDefinition.organizationId,
      page: {
        size: 100,
      },
      sort: 'name',
    })
  );

  if (isPending) {
    return <Skeleton variant="rectangular" height={40} />;
  }
  if (isError) {
    return <Alert error={error} title="Failed to load assistants" />;
  }

  return (
    <BlockSelectField
      label="Assistant ID"
      fieldName="config.assistantId"
      options={assistants.data.map((assistant) => ({
        label: assistant.name,
        value: assistant.id,
      }))}
    />
  );
}
